import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthCognitoService } from '../auth/auth-cognito.service';
import { AuthViewModel } from '../auth/auth.view-model';
import { ENV_CONFIG_TOKEN } from '../shared/config';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  #config = inject(ENV_CONFIG_TOKEN);
  #injector = inject(Injector);

  // Lazy-loaded to break circular dependency with HttpClient
  private get authViewModel(): AuthViewModel {
    return this.#injector.get(AuthViewModel);
  }

  private get authCognito(): AuthCognitoService {
    return this.#injector.get(AuthCognitoService);
  }

  private static embedToken(
    request: HttpRequest<unknown>,
    AuthorizationValue: string,
  ): HttpRequest<unknown> {
    if (!AuthorizationValue) {
      return request;
    }

    const headers = request.headers.append('Authorization', AuthorizationValue);
    return request.clone({ headers });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.#config.isStandalone) {
      return this.authCognito.getAuthorizationToken().pipe(
        map((token) => {
          return AuthTokenInterceptor.embedToken(request, token);
        }),
        switchMap((req) => next.handle(req)),
      );
    }
    return this.authViewModel.token$.pipe(
      map((token) => AuthTokenInterceptor.embedToken(request, token)),
      switchMap((req) => next.handle(req)),
    );
  }
}
